import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.operation_1 = operation;
        this.requestUuid_1 = null;
        this.executionContext_1 = Companion_getInstance().Empty_1;
        this.url_1 = null;
        this.httpMethod_1 = null;
        this.httpHeaders_1 = null;
        this.enableAutoPersistedQueries_1 = null;
        this.sendApqExtensions_1 = null;
        this.sendDocument_1 = null;
        this.canBeBatched_1 = null;
        this.ignoreUnknownKeys_1 = null;
        this.ignoreApolloClientHttpHeaders_1 = null;
        this.retryOnError_1 = null;
        this.failFastIfOffline_1 = null;
        this.sendEnhancedClientAwareness_1 = true;
        this.extensions_1 = null;
        this.onError_1 = null;
      }
      requestUuid_f5bk3d_k$(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.requestUuid_1 = requestUuid;
        return this;
      }
      executionContext_as7v8i_k$(executionContext) {
        // Inline function 'kotlin.apply' call
        this.executionContext_1 = executionContext;
        return this;
      }
      ignoreApolloClientHttpHeaders_6gabb2_k$(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.ignoreApolloClientHttpHeaders_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      url_z52zc8_k$(url) {
        // Inline function 'kotlin.apply' call
        this.url_1 = url;
        return this;
      }
      httpMethod_x6p6an_k$(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.httpMethod_1 = httpMethod;
        return this;
      }
      httpHeaders_51sthb_k$(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.httpHeaders_1 = httpHeaders;
        return this;
      }
      addHttpHeader_irkgza_k$(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.httpHeaders_1;
        tmp.httpHeaders_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      sendApqExtensions_jf5wma_k$(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.sendApqExtensions_1 = sendApqExtensions;
        return this;
      }
      sendDocument_qq2yvh_k$(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.sendDocument_1 = sendDocument;
        return this;
      }
      enableAutoPersistedQueries_n8ln2t_k$(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.enableAutoPersistedQueries_1 = enableAutoPersistedQueries;
        return this;
      }
      canBeBatched_tnoh06_k$(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.canBeBatched_1 = canBeBatched;
        return this;
      }
      ignoreUnknownKeys_bt649o_k$(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.ignoreUnknownKeys_1 = ignoreUnknownKeys;
        return this;
      }
      retryOnError_f7vl8x_k$(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.retryOnError_1 = retryOnError;
        return this;
      }
      failFastIfOffline_9dg0ak_k$(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.failFastIfOffline_1 = failFastIfOffline;
        return this;
      }
      sendEnhancedClientAwareness_gxmi9z_k$(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.sendEnhancedClientAwareness_1 = sendEnhancedClientAwareness;
        return this;
      }
      extensions_sh2glh_k$(extensions) {
        // Inline function 'kotlin.apply' call
        this.extensions_1 = extensions;
        return this;
      }
      build_1k0s4u_k$() {
        var tmp1_operation = this.operation_1;
        var tmp0_elvis_lhs = this.requestUuid_1;
        var tmp2_requestUuid = tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs;
        var tmp3_executionContext = this.executionContext_1;
        var tmp4_httpMethod = this.httpMethod_1;
        var tmp5_httpHeaders = this.httpHeaders_1;
        var tmp6_sendApqExtensions = this.sendApqExtensions_1;
        var tmp7_sendDocument = this.sendDocument_1;
        var tmp8_enableAutoPersistedQueries = this.enableAutoPersistedQueries_1;
        var tmp9_canBeBatched = this.canBeBatched_1;
        var tmp10_ignoreApolloClientHttpHeaders = this.ignoreApolloClientHttpHeaders_1;
        var tmp11_retryOnError = this.retryOnError_1;
        var tmp12_failFastIfOffline = this.failFastIfOffline_1;
        var tmp13_ignoreUnknownKeys = this.ignoreUnknownKeys_1;
        var tmp14_sendEnhancedClientAwareness = this.sendEnhancedClientAwareness_1;
        var tmp15_url = this.url_1;
        var tmp16_extensions = this.extensions_1;
        var tmp17_onError = this.onError_1;
        return new (ApolloRequest())(tmp1_operation, tmp2_requestUuid, tmp16_extensions, tmp17_onError, tmp3_executionContext, tmp15_url, tmp4_httpMethod, tmp5_httpHeaders, tmp6_sendApqExtensions, tmp7_sendDocument, tmp8_enableAutoPersistedQueries, tmp9_canBeBatched, tmp13_ignoreUnknownKeys, tmp10_ignoreApolloClientHttpHeaders, tmp11_retryOnError, tmp12_failFastIfOffline, tmp14_sendEnhancedClientAwareness);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, extensions, onError, executionContext, url, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreUnknownKeys, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.operation_1 = operation;
        this.requestUuid_1 = requestUuid;
        this.extensions_1 = extensions;
        this.onError_1 = onError;
        this.executionContext_1 = executionContext;
        this.url_1 = url;
        this.httpMethod_1 = httpMethod;
        this.httpHeaders_1 = httpHeaders;
        this.sendApqExtensions_1 = sendApqExtensions;
        this.sendDocument_1 = sendDocument;
        this.enableAutoPersistedQueries_1 = enableAutoPersistedQueries;
        this.canBeBatched_1 = canBeBatched;
        this.ignoreUnknownKeys_1 = ignoreUnknownKeys;
        this.ignoreApolloClientHttpHeaders_1 = ignoreApolloClientHttpHeaders;
        this.retryOnError_1 = retryOnError;
        this.failFastIfOffline_1 = failFastIfOffline;
        this.sendEnhancedClientAwareness_1 = sendEnhancedClientAwareness;
      }
      newBuilder_dnl2aj_k$() {
        return this.newBuilder_efzah0_k$(this.operation_1);
      }
      newBuilder_efzah0_k$(operation) {
        return (new (Builder())(operation)).requestUuid_f5bk3d_k$(this.requestUuid_1).executionContext_as7v8i_k$(this.executionContext_1).url_z52zc8_k$(this.url_1).httpMethod_x6p6an_k$(this.httpMethod_1).httpHeaders_51sthb_k$(this.httpHeaders_1).sendApqExtensions_jf5wma_k$(this.sendApqExtensions_1).sendDocument_qq2yvh_k$(this.sendDocument_1).enableAutoPersistedQueries_n8ln2t_k$(this.enableAutoPersistedQueries_1).canBeBatched_tnoh06_k$(this.canBeBatched_1).retryOnError_f7vl8x_k$(this.retryOnError_1).failFastIfOffline_9dg0ak_k$(this.failFastIfOffline_1).ignoreApolloClientHttpHeaders_6gabb2_k$(this.ignoreApolloClientHttpHeaders_1).ignoreUnknownKeys_bt649o_k$(this.ignoreUnknownKeys_1).sendEnhancedClientAwareness_gxmi9z_k$(this.sendEnhancedClientAwareness_1).extensions_sh2glh_k$(this.extensions_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
